// extracted by mini-css-extract-plugin
export default {"mainWindow":"styles_mainWindow__F8Iq3","contentWindow":"styles_contentWindow__e4N9-"};